<template>
  <v-card>
    <v-card-text v-if="editingPost">
      <div class="d-flex align-center flex-row">
        <v-avatar>
          <v-img :src="userProfilePic"></v-img>
        </v-avatar>
        <v-divider vertical inset class="ml-4 my-4"></v-divider>
        <div class="d-flex flex-column" style="width: 100%">
          <div class="d-flex justify-space-between align-center">
            <v-card-title class="ml-2 pb-0">{{ userName }}</v-card-title>
            <div class="d-flex flex-column align-end">
              <div class="mt-2">{{ agoTime(postDate) }}</div>
              <ScheduleDialog
                v-if="isScheduled"
                :editingDate="postDate"
                :enabled="canPost"
                @post="updateDate"
              />
            </div>
          </div>
          <v-textarea
            :rows="1"
            auto-grow
            clearable
            rounded
            :label="$t('common.shareGroupLabel')"
            v-model="postText"
          ></v-textarea>
        </div>
      </div>
      <v-row class="mt-1" v-if="images">
        <v-col v-for="(image, i) in images" :key="i" sm="4" md="3">
          <v-card>
            <v-img height="100px" :src="image" />
          </v-card>
        </v-col>
      </v-row>
      <v-card v-else-if="pdf" class="py-auto text-center pt-2" max-width="200px">
        <v-img
          class="mx-auto"
          width="100px"
          height="100px"
          contain
          :src="require('@/assets/pdf.png')"
        ></v-img>
        <h4 class="mt-2 mx-auto py-2 grey lighten-2">{{ pdf.name }}</h4>
      </v-card>
    </v-card-text>
    <v-card-actions class="grey lighten-2">
      <v-switch v-model="canComment" label="Allow Comments" hide-details class="my-0"> </v-switch>
      <v-spacer></v-spacer>

      <v-btn @click="cancel()" color="primary" text>
        {{ $t("common.cancel") }}
      </v-btn>
      <v-btn :disabled="!canPost" :loading="sending" @click="updatePost()" class="primary">
        {{ $t("common.update") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import firestore from "@/firebase/firestore";
import storage from "@/firebase/storage";
import ScheduleDialog from "./ScheduleDialog";

export default {
  props: ["editingPost"],
  components: { ScheduleDialog },
  data: () => ({
    postText: "",
    canComment: true,
    postDate: null,
    isScheduled: false,
    sending: false,

    images: null,
    imageFiles: null,
    resizedImages: null,

    pdf: null,
    newPollDialog: false,
  }),
  watch: {
    editingPost(postId) {
      if (postId) {
        console.log("editingPost", postId);

        let post = this.$store.state.trip.feed[postId];
        if (post) {
          this.isScheduled = false;
          this.parsePost(post);
        } else {
          post = this.$store.state.trip.scheduled[postId];
          this.isScheduled = true;
          this.parsePost(post);
        }
        console.log(post);
      }
    },
  },
  created() {
    const postId = this.$props.editingPost;
    if (postId) {
      let post = this.$store.state.trip.feed[postId];
      if (post) {
        this.isScheduled = false;
        this.parsePost(post);
      } else {
        post = this.$store.state.trip.scheduled[postId];
        this.isScheduled = true;
        this.parsePost(post);
      }
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    async parsePost(post) {
      this.postText = post.text;
      this.postDate = post.date.toDate();
      this.canComment = post.allow_comments == null ? true : post.allow_comments;
      if (post.files) {
        if (Object.keys(post.files).length === 1) {
          const file = Object.values(post.files)[0];

          if (file.includes(".pdf")) {
            this.pdf = { name: file.split("/").pop().split("-").pop() };
          } else {
            this.pdf = null;
            if (file.includes(".mp4")) {
              this.images = await Promise.all([storage.getDownloadURL(`${file}-thumbnail.jpg`)]);
            } else {
              this.images = await Promise.all([storage.getDownloadURL(file)]);
            }
          }
        } else {
          this.images = await Promise.all(Object.values(post.files).map(storage.getDownloadURL));
        }
      }
    },
    updateDate(date) {
      this.postDate = date;
    },
    async updatePost() {
      this.sending = true;

      const data = {
        text: this.postText,
        allow_comments: this.canComment,
      };
      let collection = "feed";
      if (this.isScheduled) {
        data.date = this.postDate;
        data.scheduled_date = this.postDate;
        collection = "scheduled";
      }

      const tripId = this.$store.getters.currentTripId;

      await firestore.writeTrackedDocument(tripId, collection, data, this.$props.editingPost);
      this.sending = false;
      this.$emit("close");
    },

    agoTime(date) {
      const now = new Date();
      if (!date) return "";
      if (now.getTime() > date.getTime()) {
        return `${this.$t("common.time.ago", {
          time: this.$options.filters.timeDistanceFromNow(date, now),
        })}`;
      }
      return `${this.$t("common.time.scheduled")} : ${this.$options.filters.toDate(date, "Pp")}`;
    },
  },
  computed: {
    userId() {
      return this.$store.state.firUser.uid;
    },
    userName() {
      return this.$store.getters.userShortName(this.userId);
    },
    userProfilePic() {
      return this.$store.getters.getImageUrlById(this.userId);
    },
    canPost() {
      return this.postText !== "" || this.pdf || this.imageFiles;
    },
  },
};
</script>
